import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  perfis = environment.perfisUser;

  // Variáveis de controle para os perfis
  perfilAdmin = false;
  perfilPatrocInterna = false;
  perfilNormativo = false;
  perfilTecnico = false;
  perfilCadastro = false;
  perfilArrecadacao = false;
  perfilEmprestimo = false;
  perfilConsignataria = false;
  perfilCalculoRetroativo = false;

  constructor(private msalService: MsalService) {}

  // Método para verificar os grupos do usuário
  verificarPerfis(): void {
    const groups = this.msalService.instance.getAllAccounts()[0].idTokenClaims?.groups;

    if (Array.isArray(groups)) {
      this.checarPerfil(groups);
    } else {
      console.error('Grupos não encontrados ou inválidos');
    }
  }

  private checarPerfil(groups: string[]): void {
    groups.forEach(group => {
      if (this.perfis.pta_administradores === group) {
        this.perfilAdmin = true;
      } else if (this.perfis.pta_normativos === group) {
        this.perfilNormativo = true;
      } else if (this.perfis.pta_tecnico === group) {
        this.perfilTecnico = true;
      } else if (this.perfis.pta_patrocinadoras_internas === group) {
        this.perfilPatrocInterna = true;
      } else if (this.perfis.pta_emprestimo === group) {
        this.perfilEmprestimo = true;
      } else if (this.perfis.pta_cadastro === group) {
        this.perfilCadastro = true;
      } else if (this.perfis.pta_arrecadacao === group) {
        this.perfilArrecadacao = true;
      } else if (this.perfis.pta_consignataria === group) {
        this.perfilConsignataria = true;
      } else if (this.perfis.pta_calculo_retroativo === group) {
        this.perfilCalculoRetroativo = true;
      }
    });
  }

  // Métodos para retornar os perfis específicos
  getPerfilAdmin() {
    return this.perfilAdmin;
  }

  getPerfilPatrocInterna() {
    return this.perfilPatrocInterna;
  }

  getPerfilNormativo() {
    return this.perfilNormativo;
  }

  getPerfilTecnico() {
    return this.perfilTecnico;
  }

  getPerfilCadastro() {
    return this.perfilCadastro;
  }

  getPerfilArrecadacao() {
    return this.perfilArrecadacao;
  }

  getPerfilEmprestimo() {
    return this.perfilEmprestimo;
  }

  getPerfilConsignataria() {
    return this.perfilConsignataria;
  }

  getPerfilCalculoRetroativo() {
    return this.perfilCalculoRetroativo;
  }
}
